<template>
  <div class="career-manage-recruiment">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <h6 class="font-semibold m-0">Danh sách tin tuyển dụng</h6>
          <router-link :to="{ name: 'ControllerCreateRecruitment' }">
            <a-button type="primary" class="ml-20">Thêm mới</a-button>
          </router-link>
        </a-row>
      </template>
      <a-table
        :columns="columns"
        :loading="callingAPI"
        :data-source="dataSource"
        :pagination="pagination"
        @change="handleTableChangePage"
        rowKey="id"
      >
        <template slot="category_name" slot-scope="row">
          <span>{{ row.career_category.name || "" }}</span>
        </template>
        <template slot="created_at" slot-scope="created_at">
          <span>{{ created_at | formatDate }}</span>
        </template>
        <template slot="start_receive" slot-scope="start_receive">
          <span>{{ start_receive | formatDate }}</span>
        </template>
        <template slot="expiration_date" slot-scope="expiration_date">
          <span>{{ expiration_date | formatDate }}</span>
        </template>
        <template slot="status" slot-scope="row">
          <a-switch
            v-model="row.status"
            :loading="row.loadingActive"
            @change="handleUpdate(row)"
          />
        </template>
        <template slot="action" slot-scope="row">
          <a-space>
            <router-link
              :to="{
                name: 'ControllerUpdateRecruitment',
                params: { id: row.id },
              }"
            >
              <a-button shape="circle" icon="edit" size="small" />
            </router-link>
            <a-popconfirm
              placement="topRight"
              ok-text="Xóa"
              cancel-text="Hủy"
              @confirm="remove(row)"
            >
              <template slot="title">
                <p>Xóa {{ row.title }} ??</p>
              </template>
              <a-button
                type="danger"
                shape="circle"
                icon="delete"
                size="small"
              />
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import {
  fetchRecruiment,
  updateRecruiment,
  removeRecruiment,
} from "@/services/landing-page/career/career";
import dayjs from "dayjs";
export default {
  name: "ManageRecruiment",
  data() {
    return {
      pagination: {
        total: 0,
        pageSize: 10,
      },
      currentPage: 1,

      dataSource: [],
      columns: [
        {
          title: "Tiêu đề",
          dataIndex: "title",
          scopedSlots: { customRender: "title" },
          class: "font-semibold",
        },
        {
          title: "Công ty",
          dataIndex: "company_name",
          scopedSlots: { customRender: "company_name" },
        },
        {
          title: "Ngành nghề",
          scopedSlots: { customRender: "category_name" },
          width: "150px",
        },
        {
          title: "Ngày tạo",
          dataIndex: "created_at",
          scopedSlots: { customRender: "created_at" },
          width: "150px",
        },
        {
          title: "Ngày nhận CV",
          dataIndex: "start_receive",
          scopedSlots: { customRender: "start_receive" },
          width: "150px",
        },
        {
          title: "Ngày hết hạn",
          dataIndex: "expiration_date",
          scopedSlots: { customRender: "expiration_date" },
          width: "150px",
        },
        {
          title: "Hiển thị",
          scopedSlots: { customRender: "status" },
          fixed: "right",
          width: 100,
        },
        {
          title: "",
          scopedSlots: { customRender: "action" },
          fixed: "right",
          width: "130px",
        },
      ],
    };
  },
  async beforeMount() {
    await this.loadData();
  },
  methods: {
    async loadData(loading = true) {
      try {
        this.callingAPI = loading;
        const params = {
          per_page: this.pagination.pageSize,
          page: this.currentPage,
        };
        const response = await fetchRecruiment(params);
        this.dataSource = response.data.data.map((d) => ({
          ...d,
          status: d.status === 1,
          loadingActive: false,
        }));
        this.pagination.total = response.data.total;
        this.callingAPI = false;
      } catch (error) {}
    },

    async handleTableChangePage(pagination) {
      this.currentPage = pagination.current;
      await this.loadData();
    },

    async handleUpdate(row) {
      const index = this.dataSource.findIndex((r) => r.id === row.id);
      this.dataSource[index].loadingActive = true;
      console.log(row);
      try {
        const data = {
          ...row,
          start_receive: dayjs(row.start_receive).format("DD/MM/YYYY"),
          expiration_date: dayjs(row.expiration_date).format("DD/MM/YYYY"),
          status: row.status ? 1 : 2,
          _method: "PUT",
        };
        delete data.id;
        const response = await updateRecruiment(row.id, data);
        this.dataSource[index].loadingActive = false;
        if (response.status === 1) {
          this.$notification.success({
            message: "Thành công",
            description: "Cập nhật trạng thái hiển thị thành công.",
          });
        } else {
          this.dataSource[index].status = !this.dataSource[index].status;
          this.$notification.error({
            message: "Thất bại",
            description: "Cập nhật trạng thái hiển thị thất bại.",
          });
        }
      } catch (error) {
        this.dataSource[index].loadingActive = false;
      }
    },

    async remove(row) {
      try {
        this.callingAPI = true;
        await removeRecruiment(row.id);
        await this.loadData();
        this.$notification.success({
          message: "Thành công",
          description: "Xóa thành công.",
        });
      } catch (error) {
        this.callingAPI = false;
        this.$notification.erorr({
          message: "Thất bại",
          description: "Xóa thất bại.",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>